import styled from 'styled-components';

export const OverflowVisible = styled.div`
  position: relative;
  overflow: visible;
`;
